var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMsgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2147223765"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 516",
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#0085FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "01 align center"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.08804 12.9866C8.83687 13.0584 8.6088 13.1945 8.42639 13.3815C8.24397 13.5684 8.11354 13.7998 8.04799 14.0527C7.98245 14.3055 7.98407 14.5711 8.05268 14.8231C8.12129 15.0752 8.25453 15.3049 8.4392 15.4897L10.9985 18.046V22.9861H15.9439L18.5205 25.5589C18.6588 25.6984 18.8233 25.8092 19.0045 25.8849C19.1858 25.9606 19.3802 25.9997 19.5766 26C19.7057 25.9997 19.8342 25.9831 19.9591 25.9505C20.2119 25.8868 20.4434 25.7577 20.6304 25.5761C20.8174 25.3945 20.9532 25.1669 21.0243 24.9161L26.0004 8L9.08804 12.9866ZM9.50509 14.4291L22.2777 10.6636L12.5002 20.4253V17.4249L9.50509 14.4291ZM19.5863 24.4983L16.5657 21.4859H13.5653L23.3413 11.7182L19.5863 24.4983Z",
    fill: "#F9FAFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsgSendIcon);
export default __webpack_public_path__ + "static/media/msgSendIcon.6ed2ae6a9d682372a301d123d5111c3d.svg";
export { ForwardRef as ReactComponent };